<script>
import { onMount } from "svelte";


  let title = 'Still moving in...';
  let info = 'The boxes are off the curb but unfortunately we\'ve still gotta move them in.<br>Kindly check back later when we\'ve settled in.';

  onMount(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 200);
  });
</script>

<style>
  #coming-soon {
    min-height: 460px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: var(--primary-light);
    color: var(--primary-text);
    padding: 150px;
    text-align: center;
  }

  #coming-soon .title {
    color: var(--primary-text) !important;
  }
</style>

<main id="coming-soon">
  <h1 class="title">{title}</h1>
  <p class="lead-paragraph">{@html info}</p>
</main>